/**
 *
 * @module appTicketsShared
 * @author Terrence Lee [terrence.lee@mlb.com]
 * @description Commons
 *
 */

/* jshint newcap:false */

define(function() {

    return {
        /**
         *
         * @method smoothScroll
         * @param {String} CSS selector
         *
         */
        smoothScroll: function( selector, ms ) {
            var target = $( selector );
            if ( target.length ) {
                $("html,body").animate({
                    scrollTop: target.offset().top
                }, ms || 500 );
            }
        },


        /**
         *
         * @method registerPartials
         * @description inits templates
         * @param {Handlebars} handlebars instance
         * @param {Object} templates the shared partials
         * @param {Array} partials the partials to register
         *
         */
        registerPartials: function( handlebars, templates, partials ) {
            partials.forEach(function( partialName ) {
                var partial;
                if ( ( partial = templates[ partialName ] ) ) {
                    handlebars.registerPartial( partialName, partial );
                }
            });
        },


        /**
         *
         * @method registerHelpers
         * @description inits helpers
         * @param {Handlebars} handlebars instance
         * @param {Object} Helpers
         *
         */
        registerHelpers: function( handlebars, helpers ) {
            for ( var helper in helpers ) {
                handlebars.registerHelper( helper, helpers[ helper ] );
            }
        },


        /**
         *
         * @function bindDebugEvents
         * @description bind debug template listeners
         * @param {JQuery} $root Root context of where debugger lives
         *
         */
        bindDebugEvents: function( $root ) {
            $( document ).off("keypress.smt-cc").on("keypress.smt-cc", function( e ) {
                if ( e.which === 72 ) {
                    $( ".app-tickets-debugger" ).toggle();
                }
            });

            $root.on( "click", ".app-tickets-debugger button", function( event ) {
                $( this ).next().toggle();
                event.preventDefault();
            });
        },


        /**
         *
         * @method scrollTopInit
         * @description setup scroll to top functionality
         * @param {Object} init options.
         *
         */
        scrollTopInit: function( opts ) {

            var self = this,
                elementWatcher = opts.scrollMonitor.create( opts.containerId ),
                scrollContainer = $( "#" + opts.arrowId ),
                scrollArrow = $( "." + opts.arrowClass, scrollContainer );

            if ( opts.stickyFill ) {
                opts.stickyFill.add( scrollContainer[ 0 ] );
            }

            elementWatcher.stateChange(function() {
                scrollContainer[ elementWatcher.isAboveViewport ?
                    "addClass" : "removeClass" ]( opts.fixedClass );
            });

            scrollArrow.on( "click", function( e ) {
                e.preventDefault();
                self.smoothScroll( e.target.hash );
            });
        },


        /**
         *
         * @method prepParams
         * @description prepare params for service calls
         * @param {Object} params
         *
         */
        prepParams: function( params ) {
            var param;

            for ( param in params ) {
                if ( /\,/.test( params[ param ] ) ) {
                    params[ param ] = params[ param ].split( "," );
                }
            }
            return params;
        },


        /**
         *
         * @function paramsToKeyVal
         *
         * @param {Object} params
         *
         */
        paramsToKeyVal: function( params ) {
            var paramsOut = {};
            if ( params ) {
                params.forEach(function( param ) {
                    if ( param.name && param.value ) {
                        paramsOut[ param.name ] = param.value;
                    }
                });
            }
            return paramsOut;
        },


        /**
         * @method tflGenerator
         * @description Append found selectors href's with TFL tracking param
         * @param {String|Object} config  Config of TFL options per impl
         * @param {JQuery} [$scope] - Confining scope
         *
         */
        tflGenerator: function( config, $scope ) {
            var tflData = ( typeof config === "string" ? JSON.parse( config ) : config ) || {},
                omPageName = ( window.o && window.o.pageName ) ||
                    ( window.s && window.s.pageName ),
                exclusions = ":not([data-tfl='skip'])",
                configValid = /(Array|Object)]$/.test(
                    Object.prototype.toString.call( tflData.config ) ),
                configType = RegExp.$1,
                makeTFL = function( tflParts, tflConfig ) {
                    // Order is imperative
                    return tflParts.concat([
                        tflConfig.module || "na",
                        tflConfig.pos || "x0"
                    ]).join("-");
                },
                setTFL = function( tflConfig, tfl ) {
                    qualifier = tflConfig.qualifier || /.*/;
                    tflConfig.selector += exclusions;

                    $( tflConfig.selector, $scope || "body" ).each(function() {
                        $el =  $( this );
                        if ( $el.is("a") ) {
                            href = $el.attr("href");
                            if ( ( qualifier && qualifier.test( href ) ) &&
                                href.indexOf("tfl=") === -1 ) {
                                href += ( href.indexOf("?") > -1 ? "&" : "?" ) + "tfl=" + tfl;
                                $el.attr( "href", href );
                            }
                        }
                        $el.attr( "data-tfl", "skip" );
                    });
                },
                tflParts, tfl, tflReturn, $el, href, qualifier;

            if ( omPageName ) {

                omPageName = ( omPageName.split(": ").length < 3 ) ?
                    omPageName.replace( /(: .+)$/, "$1$1" ) : omPageName;

                tflParts = omPageName.replace( /(:\s|[:\s\-'])/g, function( $0 ) {
                    switch ( $0 ) {
                        case ":":
                            omPageNameDelimeter = "}";
                            break;
                        case "-":
                            omPageNameDelimeter = "~";
                            break;
                        case " ":
                            omPageNameDelimeter = "_";
                            break;
                        case "'":
                            omPageNameDelimeter = "";
                            break;
                        case ": ":
                            omPageNameDelimeter = "||";
                            break;
                    }
                    return omPageNameDelimeter;
                }).split("||");

                if ( configValid ) {
                    if ( configType.toLowerCase() === "array" ) {
                        tflData.config.forEach(function( tflConfig ) {
                            tflReturn = tflReturn || [];
                            tfl = makeTFL( tflParts, tflConfig );
                            tflReturn.push( tfl );
                            setTFL( tflConfig, tfl );
                        });
                    } else {
                        tflReturn = makeTFL( tflParts, tflData.config );
                        setTFL( tflData.config, tflReturn );
                    }
                } else {
                    tflReturn = makeTFL( tflParts );
                }
            }

            return tflReturn;
        },


        /**
         * @method getParamValueByName
         * @description Grab a query string value by name
         * @param {String} name  Name of the value
         *
         */
        getParamValueByName: function( name ) {
            name = name.replace( /[\[\]]/g, "\\$&" );
            var url = window.location.href,
                regex = new RegExp( "[?&]" + name + "(=([^&#]*)|&|#|$)" ),
                results = regex.exec( url );
            if ( !results ) { return null; }
            if ( !results[ 2 ] ) { return ""; }
            return decodeURIComponent( results[ 2 ].replace( /\+/g, " " ) );
        },


        /**
         * @method fevoInit
         * @description add fevo button items to ticket links
         * @param {JQuery} [$scope] - Confining scope
         *
         */
        fevoInit: function( $scope ) {
            var fevoLinks = false,
                eventKey, urlParts;

            $( ".ticket-link a", $scope ).each(function() {
                if ( this.href.indexOf( "https://www.fevo.com" ) > -1 ) {
                    urlParts = this.href.split( "/" );
                    eventKey = urlParts[ urlParts.length - 1 ];
                    $( this ).addClass( "fevo-button" );
                    $( this ).attr( "data-event-key", eventKey );
                    fevoLinks = true;
                }
            });

            if ( fevoLinks === true && !$( "body" ).hasClass( "fevo-init" ) ) {
                $.getScript( "https://sdk.fevo.com/v1/fevo.js", function() {
                    $( "body" ).addClass( "fevo-init" );
                    Fevo.init({
                        publisherKey: "71fc69f8-dc07-4a60-ae28-4370ad0db651",
                        env: "prod"
                    });
                    Fevo.purchase( ".fevo-button" );
                });
            }
        }

    };

});

